import { PendingPayableRow } from 'services/reportsApi';

const HEADERS = [
  'Property',
  'Vendor',
  'Amount',
  'Invoice #',
  'Due date',
  'Pending since',
  'Days pending',
] as const;

// first_seen_at arrives as a full ISO timestamp; export the date portion.
const fmtIsoDate = (raw: string | null): string => {
  if (!raw) return '';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
};

const fmtDate = (raw: string | null): string => {
  if (!raw) return '';
  const d = new Date(`${raw}T00:00:00`);
  if (Number.isNaN(d.getTime())) return raw;
  return d.toISOString().slice(0, 10);
};

const escapeCell = (raw: string | number | null | undefined): string => {
  if (raw === null || raw === undefined) return '';
  const s = String(raw);
  if (/[",\r\n]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
};

export const toCsv = (rows: PendingPayableRow[]): string => {
  const lines = [HEADERS.join(',')];
  for (const r of rows) {
    lines.push(
      [
        escapeCell(r.propertyName ?? ''),
        escapeCell(r.vendorName ?? r.vendorCode ?? ''),
        escapeCell(r.amount),
        escapeCell(r.invoiceNo ?? ''),
        escapeCell(fmtDate(r.dueDate)),
        escapeCell(fmtIsoDate(r.firstSeenAt)),
        escapeCell(r.daysPending),
      ].join(',')
    );
  }
  return lines.join('\r\n');
};

export const csvFilename = (now: Date = new Date()): string => {
  const yyyy = now.getUTCFullYear();
  const mm = String(now.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(now.getUTCDate()).padStart(2, '0');
  return `pending-payables-${yyyy}-${mm}-${dd}.csv`;
};

export const triggerCsvDownload = (csv: string, filename: string): void => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
